import { extendTheme } from "@chakra-ui/react";



 const theme = extendTheme({
    styles: {
        global : {
            body: {      
                bg: 'blackAlpha.900',
                color: 'whiteAlpha.900',
                fontFamily: 'Work Sans',
            },
    }
   }
})

export default theme